// eslint-disable-next-line
// @ts-nocheck
import { i18n } from '@/lang/i18n';
import { pinia } from '@/store';
import { useCommonStore } from '@/store/common';
import { isPC } from '@/utils/tools';

const { t } = i18n.global;
const commonStore = useCommonStore(pinia);

import { RESOURCE_USER_REFERRAL } from '@/config/userRolePermission';

// 创建一个预加载glossary数据的函数
const preloadGlossaryData = async() => {
  // 在SSR环境中，我们需要确保数据可用
  if (import.meta.env.SSR) {
    try {
      // 动态导入glossary hooks来确保数据加载
      const { useGlossary } = await import('@/pages/glossary/hooks');

      // 调用hooks来初始化数据
      const glossaryHooks = useGlossary();
      console.log('[Glossary Router] Glossary数据预加载完成');

      return glossaryHooks;
    } catch (error) {
    }
  }
};

// 增长路由 15个
const growth = [
  {
    path: '/safeWay',
    component: () => import('@/pages/safeWay/index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_safeway_meta_title'),
      description: t('tdk_safeway_meta_description'),
      keywords: t('tdk_safeway_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/safeWay/Public-Courses/what-is-:id',
    alias: '/safeWay/Public-Courses/token-preview-:id',
    component: () => import('@/pages/safeWay/content.vue'),
    meta: {
      layout: 'default',
      ssg: {}
    }
  },
  {
    path: '/trade/otc',
    component: () => import('@/pages/hashBrokerage/Index.vue'),
    meta: {
      title: t('tdk_hashbrokerage_meta_title'),
      description: t('tdk_hashbrokerage_meta_description'),
      keywords: t('tdk_hashbrokerage_meta_keywords'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/trade/otc/' : ''
  },
  {
    path: '/trade/otc/:symbolPath',
    component: () => import('@/pages/hashBrokerage/Index.vue'),
    meta: {
      title: t('HashKey 数字货币经纪商项目 - HashKey Exchange - 买币更方便，存币更安心'),
      description: t('借助 HashKey 经纪商计划，您可以用 HashKey 交易所的技术打造自己的数字资产平台，并从每笔交易中分红。'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/trade/otc/' : ''
  },
  {
    path: '/convert',
    component: () => import('@/pages/hash-rfq/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_rfq_meta_title'),
      description: t('tdk_rfq_meta_description'),
      keywords: t('tdk_rfq_meta_keywords'),
      // HKEX-11019 放开访问权限
      // auth: 'login',
      props: {
        header: { theme: 'dark', border: true, class: 'rfq-header' },
        footer: false
      },
      ssg: {}
    }
  },
  {
    path: '/convert/:symbolPath',
    component: () => import('@/pages/hash-rfq/Index.vue'),
    meta: {
      layout: 'default',
      // HKEX-11019 放开访问权限
      // auth: 'login',
      props: {
        header: { theme: 'dark', border: true, class: 'rfq-header' },
        footer: false
      },
      ssg: {}
    }
  },
  {
    path: '/hashBrokerage',
    redirect: '/trade/otc'
  },
  {
    path: '/hashrfq',
    redirect: '/convert'
  },
  {
    path: '/h5/trade/otc',
    component: () => import('@/pages/hashBrokerage/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_hashbrokerage_h5_meta_title'),
      description: t('tdk_hashbrokerage_h5_meta_description'),
      keywords: t('tdk_hashbrokerage_h5_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/h5/hashBrokerage',
    redirect: '/h5/trade/otc'
  },
  {
    path: '/h5/trade/otc/concatUs',
    component: () => import('@/pages/hashBrokerage/h5/contactUs.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_hashbrokerage_h5_contactus_meta_title'),
      description: t('tdk_hashbrokerage_h5_contactus_meta_description'),
      keywords: t('tdk_hashbrokerage_h5_contactus_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/h5/hashBrokerage/concatUs',
    redirect: '/h5/trade/otc/concatUs'
  },
  {
    path: '/reverseCustomerAcquisition',
    component: () => import('@/pages/reverseCustomerAcquisition/Index.vue'),
    meta: {
      title: t('tdk_reverseCustomerAcquisition_meta_title'),
      description: t('tdk_reverseCustomerAcquisition_meta_description'),
      keywords: t('tdk_reverseCustomerAcquisition_meta_keywords'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    }
  },
  {
    path: '/h5/reverseCustomerAcquisition',
    component: () => import('@/pages/reverseCustomerAcquisition/H5.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_reverseCustomerAcquisition_h5_meta_title'),
      description: t('tdk_reverseCustomerAcquisition_h5_meta_description'),
      keywords: t('tdk_reverseCustomerAcquisition_h5_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/hsk/history',
    component: () => import('@/pages/hsk/Index.vue'),
    meta: {
      layout: 'default',
      auth: 'login'
      // ssg: {}
    }
  },
  {
    path: '/hsk',
    component: () => import('@/pages/hskPoints/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_hsk_meta_title'),
      description: t('tdk_hsk_meta_description'),
      keywords: t('tdk_hsk_meta_keywords'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
      //   auth: 'login'
    }
  },
  {
    path: '/h5/hsk',
    component: () => import('@/pages/hskPoints/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_h5_hsk_meta_title'),
      description: t('tdk_h5_hsk_meta_description'),
      keywords: t('tdk_h5_hsk_meta_keywords'),
      ssg: {}
      // layout: 'default',
      //   auth: 'login'
    }
  },
  {
    path: '/hskPoints',
    component: () => import('@/pages/hskPoints/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_hskpoints_meta_title'),
      description: t('tdk_hskpoints_meta_description'),
      keywords: t('tdk_hskpoints_meta_keywords'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
      //   auth: 'login'
    },
    redirect: '/hsk'
  },
  {
    path: '/h5/hskPoints',
    component: () => import('@/pages/hskPoints/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_h5_hskpoints_meta_title'),
      description: t('tdk_h5_hskpoints_meta_description'),
      keywords: t('tdk_h5_hskpoints_meta_keywords'),
      ssg: {}
      // layout: 'default',
      //   auth: 'login'
    },
    redirect: '/h5/hsk'
  },
  {
    path: '/tradeHsk',
    component: () => import('@/pages/tradeHsk/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_tradehsk_meta_title'),
      description: t('tdk_tradehsk_meta_description'),
      keywords: t('tdk_tradehsk_meta_keywords'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/tradeHsk' : ''
  },
  {
    path: '/h5/tradeHsk',
    component: () => import('@/pages/tradeHsk/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_tradehsk_h5_meta_title'),
      description: t('tdk_tradehsk_h5_meta_description'),
      keywords: t('tdk_tradehsk_h5_meta_keywords'),
      ssg: {}
    }
  },
  {
    path: '/referral',
    component: () => import('@/pages/invite/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_invite_meta_title'),
      description: t('tdk_invite_meta_description'),
      keywords: t('tdk_invite_meta_keywords'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {},
      userRolePermission: RESOURCE_USER_REFERRAL
    },
    redirect: !isPC() ? '/h5/referral' : ''
  },
  {
    path: '/referral/record',
    component: () => import('@/pages/invite/record.vue'),
    meta: {
      layout: 'default',
      auth: 'login',
      title: t('tdk_invite_record_meta_title'),
      description: t('tdk_invite_record_meta_description'),
      keywords: t('tdk_invite_record_meta_keywords')
      // ssg: {}
    }
  },
  {
    path: '/buy-crypto',
    component: () => import('@/pages/buy-cryptos/web/Index.vue'),
    meta: {
      title: t('tdk_buy_crypto_meta_title'),
      description: t('tdk_buy_crypto_meta_description'),
      keywords: t('tdk_buy_crypto_meta_keywords'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/buy-crypto' : ''
  },
  {
    path: '/buy-crypto/bitcoin',
    component: () => import('@/pages/buy-cryptos/web/currency.vue'),
    meta: {
      title: t('tdk_buy_crypto_bitcoin_meta_title'),
      description: t('tdk_buy_crypto_bitcoin_meta_description'),
      keywords: t('tdk_buy_crypto_bitcoin_meta_keywords'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/buy-crypto/bitcoin' : ''
  },
  {
    path: '/h5/buy-crypto/bitcoin',
    component: () => import('@/pages/buy-cryptos/h5/currency.vue'),
    meta: {
      title: t('tdk_buy_crypto_bitcoin_meta_title'),
      description: t('tdk_buy_crypto_bitcoin_meta_description'),
      keywords: t('tdk_buy_crypto_bitcoin_meta_keywords'),
      layout: 'h5Default',
      ssg: {}
    },
    redirect: isPC() ? '/buy-crypto/bitcoin' : ''
  },
  {
    path: '/buy-crypto/eth',
    component: () => import('@/pages/buy-cryptos/web/currency.vue'),
    meta: {
      title: t('tdk_buy_crypto_eth_meta_title'),
      description: t('tdk_buy_crypto_eth_meta_description'),
      keywords: t('tdk_buy_crypto_eth_meta_keywords'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/buy-crypto/eth' : ''
  },
  {
    path: '/h5/buy-crypto/eth',
    component: () => import('@/pages/buy-cryptos/h5/currency.vue'),
    meta: {
      title: t('tdk_buy_crypto_eth_meta_title'),
      description: t('tdk_buy_crypto_eth_meta_description'),
      keywords: t('tdk_buy_crypto_eth_meta_keywords'),
      layout: 'h5Default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: isPC() ? '/buy-crypto/eth' : ''
  },
  {
    path: '/buy-crypto/usdt',
    component: () => import('@/pages/buy-cryptos/web/currency.vue'),
    meta: {
      title: t('如何在 HashKey Exchange 购买泰达币（Tether USDt）USDT？'),
      description: t('如果您想要购买泰达币（USDT），那么HashKey Exchange是一个不错的选择。HashKey Exchange是一家专业的数字资产交易平台，支持多种泰达币交易对，包括USDT/USD和USDT/HKD，让您可以轻松地在法币和加密货币之间进行兑换。'),
      keywords: t('泰达币交易所、法币兑换泰达币、HashKey Exchange，泰达币交易平台、泰达币交易费用、泰达币交易安全、法币兑换泰达币方法、法币兑换泰达币流程、HashKey Exchange优势、HashKey Exchange评价、HashKey Exchange教程'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/buy-crypto/usdt' : ''
  },
  {
    path: '/h5/buy-crypto/usdt',
    component: () => import('@/pages/buy-cryptos/h5/currency.vue'),
    meta: {
      title: t('如何在 HashKey Exchange 购买泰达币（Tether USDt）USDT？'),
      description: t('如果您想要购买泰达币（USDT），那么HashKey Exchange是一个不错的选择。HashKey Exchange是一家专业的数字资产交易平台，支持多种泰达币交易对，包括USDT/USD和USDT/HKD，让您可以轻松地在法币和加密货币之间进行兑换。'),
      keywords: t('泰达币交易所、法币兑换泰达币、HashKey Exchange，泰达币交易平台、泰达币交易费用、泰达币交易安全、法币兑换泰达币方法、法币兑换泰达币流程、HashKey Exchange优势、HashKey Exchange评价、HashKey Exchange教程'),
      layout: 'h5Default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: isPC() ? '/buy-crypto/usdt' : ''
  },
  {
    path: '/buy-crypto/avax',
    component: () => import('@/pages/buy-cryptos/web/currency.vue'),
    meta: {
      title: t('如何在 HashKey Exchange 购买 Avalanche (AVAX)？'),
      description: t('如果您想要购买 Avalanche (AVAX)，那么HashKey Exchange是一个不错的选择。HashKey Exchange是一家专业的数字资产交易平台，支持多种AVAX交易对，包括AVAX/USD，让您可以轻松地在法币和加密货币之间进行兑换。'),
      keywords: t('AVAX交易所、法币兑换AVAX、HashKey Exchange，AVAX交易平台、AVAX交易费用、AVAX交易安全、法币兑换AVAX方法、法币兑换AVAX流程、HashKey Exchange优势、HashKey Exchange评价、HashKey Exchange教程'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/buy-crypto/avax' : ''
  },
  {
    path: '/h5/buy-crypto/avax',
    component: () => import('@/pages/buy-cryptos/h5/currency.vue'),
    meta: {
      title: t('如何在 HashKey Exchange 购买 Avalanche (AVAX)？'),
      description: t('如果您想要购买 Avalanche (AVAX)，那么HashKey Exchange是一个不错的选择。HashKey Exchange是一家专业的数字资产交易平台，支持多种AVAX交易对，包括AVAX/USD，让您可以轻松地在法币和加密货币之间进行兑换。'),
      keywords: t('AVAX交易所、法币兑换AVAX、HashKey Exchange，AVAX交易平台、AVAX交易费用、AVAX交易安全、法币兑换AVAX方法、法币兑换AVAX流程、HashKey Exchange优势、HashKey Exchange评价、HashKey Exchange教程'),
      layout: 'h5Default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: isPC() ? '/buy-crypto/avax' : ''
  },
  {
    path: '/buy-crypto/spice',
    component: () => import('@/pages/buy-cryptos/web/currency.vue'),
    meta: {
      title: t('如何在 HashKey Exchange 购买 SPICE？'),
      description: t('如果您想要购买 SPICE，那么HashKey Exchange是一个不错的选择。HashKey Exchange是一家专业的数字资产交易平台，支持多种SPICE交易对，包括SPICE/USD，让您可以轻松地在法币和加密货币之间进行兑换。'),
      keywords: t('SPICE交易所、法币兑换SPICE、HashKey Exchange，SPICE交易平台、SPICE交易费用、SPICE交易安全、法币兑换SPICE方法、法币兑换SPICE流程、HashKey Exchange优势、HashKey Exchange评价、HashKey Exchange教程'),
      layout: 'default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/buy-crypto/spice' : ''
  },
  {
    path: '/h5/buy-crypto/spice',
    component: () => import('@/pages/buy-cryptos/h5/currency.vue'),
    meta: {
      title: t('如何在 HashKey Exchange 购买 SPICE？'),
      description: t('如果您想要购买 SPICE，那么HashKey Exchange是一个不错的选择。HashKey Exchange是一家专业的数字资产交易平台，支持多种SPICE交易对，包括SPICE/USD，让您可以轻松地在法币和加密货币之间进行兑换。'),
      keywords: t('SPICE交易所、法币兑换SPICE、HashKey Exchange，SPICE交易平台、SPICE交易费用、SPICE交易安全、法币兑换SPICE方法、法币兑换SPICE流程、HashKey Exchange优势、HashKey Exchange评价、HashKey Exchange教程'),
      layout: 'h5Default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: isPC() ? '/buy-crypto/spice' : ''
  },
  {
    path: '/h5/buy-crypto',
    component: () => import('@/pages/buy-cryptos/h5/Index.vue'),
    meta: {
      title: t('tdk_buy_crypto_meta_title'),
      description: t('tdk_buy_crypto_meta_description'),
      keywords: t('tdk_buy_crypto_meta_keywords'),
      layout: 'h5Default',
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: isPC() ? '/buy-crypto' : ''
  },
  {
    path: '/h5/referral',
    component: () => import('@/pages/invite/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_invite_meta_title'),
      description: t('tdk_invite_meta_description'),
      keywords: t('tdk_invite_meta_keywords'),
      ssg: {}
    },
    redirect: isPC() ? '/referral' : ''
  },
  {
    path: '/h5/referral/information',
    component: () => import('@/pages/invite/h5/h5Information.vue'),
    meta: {
      layout: 'h5Default',
      title: t('大使认证申请'),
      ssg: {}
    }
  },
  {
    path: '/pi-institutional',
    component: () => import('@/pages/vipZone/web/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_vipzone_meta_title'),
      description: t('tdk_vipzone_meta_description'),
      keywords: t('tdk_vipzone_meta_keywords'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/pi-institutional' : ''
  },
  {
    path: '/vipZone',
    redirect: '/pi-institutional'
  },
  {
    path: '/pro-trading',
    component: () => import('@/pages/hashkeyPro/Index.vue'),
    meta: {
      layout: 'default',
      title: t('tdk_hashkeypro_meta_title'),
      description: t('tdk_hashkeypro_meta_description'),
      keywords: t('tdk_hashkeypro_meta_keywords'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/pro-trading' : ''
  },
  {
    path: '/hashkeyPro',
    redirect: '/pro-trading'
  },
  {
    path: '/h5/pro-trading',
    component: () => import('@/pages/hashkeyPro/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_hashkeypro_meta_title'),
      description: t('tdk_hashkeypro_meta_description'),
      keywords: t('tdk_hashkeypro_meta_keywords'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: isPC() ? '/pro-trading' : ''
  },
  {
    path: '/h5/hashkeyPro',
    redirect: '/h5/pro-trading'
  },
  {
    path: '/h5/pi-institutional',
    component: () => import('@/pages/vipZone/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('tdk_vipzone_meta_title'),
      description: t('tdk_vipzone_meta_description'),
      keywords: t('tdk_vipzone_meta_keywords'),
      ssg: {}
    },
    redirect: isPC() ? '/pi-institutional' : ''
  },
  {
    path: '/h5/vipZone',
    redirect: '/h5/pi-institutional'
  },
  {
    path: '/limitedTimeWelcome',
    component: () => import('@/pages/limitedTimeWelcome/web/Index.vue'),
    meta: {
      layout: 'default',
      title: t('HashKey避风港活动：新用户参与活动得BTC和ETH，最高可得400港币等值奖励'),
      description: t('加入HashKey Exchange，参与“避风港”新用户活动，领取BTC和ETH，最高可达400港币等值奖励。注册、完成KYC、入金、交易，即可享受多重奖励。香港持牌虚拟资产交易所，让您的投资更放心。'),
      keywords: t('HashKey, 避风港活动, 新用户, BTC奖励, ETH奖励, 400港币, 数字资产交易平台, 注册奖励, 入金奖励, 交易奖励, 安全交易, 数字货币, 加密货币交易'),
      props: { footer: { theme: 'dark', border: false } },
      ssg: {}
    },
    redirect: !isPC() ? '/h5/limitedTimeWelcome' : ''
  },
  {
    path: '/h5/limitedTimeWelcome',
    component: () => import('@/pages/limitedTimeWelcome/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('HashKey避风港活动：新用户参与活动得BTC和ETH，最高可得400港币等值奖励'),
      description: t('加入HashKey Exchange，参与“避风港”新用户活动，领取BTC和ETH，最高可达400港币等值奖励。注册、完成KYC、入金、交易，即可享受多重奖励。香港持牌虚拟资产交易所，让您的投资更放心。'),
      keywords: t('HashKey, 避风港活动, 新用户, BTC奖励, ETH奖励, 400港币, 数字资产交易平台, 注册奖励, 入金奖励, 交易奖励, 安全交易, 数字货币, 加密货币交易'),
      ssg: {}
    }
  },
  {
    path: '/limitedPromotion',
    component: () => import('@/pages/limitedTimeWelcome/web/Index.vue'),
    meta: {
      layout: 'default',
      title: t('header-safe-habour-title'),
      props: { footer: { theme: 'dark', border: false } }
    },
    redirect: !isPC() ? '/h5/limitedPromotion' : ''
  },
  {
    path: '/h5/limitedPromotion',
    component: () => import('@/pages/limitedTimeWelcome/h5/Index.vue'),
    meta: {
      layout: 'h5Default',
      title: t('header-safe-habour-title')
    }
  },
  {
    path: '/invite',
    redirect: '/referral'
  },
  {
    path: '/invite/record',
    redirect: '/referral/record'
  },
  {
    path: '/invite/h5',
    redirect: '/h5/referral'
  },
  {
    path: '/h5/invite/information',
    redirect: '/h5/referral/information'
  },
  {
    path: '/glossary',
    component: () => import('@/pages/glossary/index.vue'),
    meta: {
      layout: isPC() ? 'default' : 'h5Default',
      title: t('glossary.meta_title'),
      description: t('glossary.meta_description'),
      keywords: t('glossary.meta_keywords'),
      name: 'glossary',
      ignoreAuth: true,
      ssg: {
        preload: [preloadGlossaryData]
      }
    }
  },
  {
    path: '/glossary/:term',
    component: () => import('@/pages/glossary/term.vue'),
    meta: {
      layout: isPC() ? 'default' : 'h5Default',
      title: t('glossary.meta_title'),
      description: t('glossary.meta_description'),
      keywords: t('glossary.meta_keywords'),
      name: 'glossary',
      ignoreAuth: true,
      ssg: {
        preload: [preloadGlossaryData]
      }
    }
  }
];

export default growth;
